import { useSyncExternalStore } from 'react';
import { getInstallState, subscribeToInstall, promptInstall } from '../services/install';

export function useInstallPrompt() {
  const state = useSyncExternalStore(subscribeToInstall, getInstallState);
  return { ...state, promptInstall };
}
